<div class="p-dialog-header px-0">
  <div class="p-dialog-title">
    <div class="flex gap-spacing-xs align-items-center">
      <span class="title-small-bold text-primary-color">Send Mass Notification To All Guardians</span>
    </div>
  </div>
  <div class="p-dialog-header-icons">
    <app-button
      (btnClick)="ref.close()"
      [iconOnlyButton]="true"
      icon="icon-x"
      sizeClass="p-button-sm"
      severity="secondary"
      [textButton]="true"></app-button>
  </div>
</div>

<div class="content p-spacing-xl border-1 border-neutral-base-primary-border border-round-xl flex flex-column gap-spacing-xl table-bg-hover-bg">
  <form
    [formGroup]="form"
    class="flex flex-column gap-spacing-xl">
    <!-- Shared template for custom chip display -->
    <ng-template
      #chipTemplate
      let-value
      let-removeChip="removeChip"
      let-label="label"
      let-controlName="controlName"
      let-placeholder="placeholder">
      @if (value && value.length > 0) {
        <!-- Show individual chip if only 1 item selected -->
        @if (value.length === 1) {
          <div class="p-chip p-component">
            <span class="p-chip-text">{{ value[0].name }}</span>
            <button
              type="button"
              class="p-chip-remove-icon p-link"
              (click)="removeChip(value[0])">
              <i class="icon-x-circle-solid size-icon-sm icon-link-color"></i>
            </button>
          </div>
        }
        <!-- Show summary chip if 2+ items selected -->
        @if (value.length > 1) {
          <div class="p-chip p-component">
            <span class="p-chip-text">{{ value.length }} {{ label }} selected</span>
            <button
              type="button"
              class="p-chip-remove-icon p-link flex align-items-center"
              (click)="clearFormControl(controlName)">
              <i class="icon-x-circle-solid size-icon-sm icon-link-color"></i>
            </button>
          </div>
        }
      } @else {
        <span>{{ placeholder }}</span>
      }
    </ng-template>

    <div class="grid">
      <div class="col-12 lg:col-4">
        <div class="form-group flex flex-column gap-spacing-xs">
          <label
            class="input-label label-large-medium text-primary-color"
            for="clientName">
            Client(s)
            <span class="feedback-danger-fg-color">*</span>
          </label>
          <div class="form-group">
            <p-multiSelect
              #clientsMultiSelect
              [pTooltip]="clientsTooltip()"
              [autoHide]="false"
              [tooltipOptions]="tooltipOptions"
              appendTo="body"
              formControlName="clients"
              [options]="clients()"
              optionLabel="name"
              placeholder="Select Client(s)"
              [filter]="true">
              <ng-template
                #selecteditems
                let-value
                let-removeChip="removeChip">
                <ng-container *ngTemplateOutlet="chipTemplate; context: { $implicit: value, removeChip: removeChip, label: 'clients', controlName: 'clients', placeholder: 'Select Client(s)' }"></ng-container>
              </ng-template>
            </p-multiSelect>
          </div>
        </div>
      </div>

      <div class="col-12 lg:col-4">
        <div class="form-group flex flex-column gap-spacing-xs">
          <label
            class="input-label label-large-medium text-primary-color"
            for="placeName">
            Place(s)
            <span class="feedback-danger-fg-color">*</span>
          </label>
          <div class="form-group">
            <p-multiSelect
              #placesMultiSelect
              [pTooltip]="placesTooltip()"
              [autoHide]="false"
              [tooltipOptions]="tooltipOptions"
              appendTo="body"
              formControlName="places"
              [options]="places()"
              optionLabel="name"
              placeholder="Select Place(s)"
              [filter]="true">
              <ng-template
                #selecteditems
                let-value
                let-removeChip="removeChip">
                <ng-container *ngTemplateOutlet="chipTemplate; context: { $implicit: value, removeChip: removeChip, label: 'places', controlName: 'places', placeholder: 'Select Place(s)' }"></ng-container>
              </ng-template>
            </p-multiSelect>
          </div>
        </div>
      </div>

      <div class="col-12 lg:col-4">
        <div class="form-group flex flex-column gap-spacing-xs">
          <label
            class="input-label label-large-medium text-primary-color"
            for="states">
            State(s)
            <span class="feedback-danger-fg-color">*</span>
          </label>
          <div class="form-group">
            <p-multiSelect
              #statesMultiSelect
              [pTooltip]="statesTooltip()"
              [autoHide]="false"
              [tooltipOptions]="tooltipOptions"
              appendTo="body"
              formControlName="states"
              optionLabel="name"
              [options]="states()"
              placeholder="Select state(s)"
              [filter]="true">
              <ng-template
                #selecteditems
                let-value
                let-removeChip="removeChip">
                <ng-container *ngTemplateOutlet="chipTemplate; context: { $implicit: value, removeChip: removeChip, label: 'states', controlName: 'states', placeholder: 'Select state(s)' }"></ng-container>
              </ng-template>
            </p-multiSelect>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label
        class="input-label label-large-medium text-primary-color mb-spacing-default flex gap-spacing-default align-items-center"
        for="title"
        >Notification Title <span class="feedback-danger-fg-color">*</span></label
      >
      <input
        id="title"
        formControlName="title"
        type="text"
        placeholder="Enter Notification Title"
        pInputText
        class="w-full" />
      @if (form.get("title")?.invalid && form.get("title")?.touched) {
        <small class="p-error">Notification title is required </small>
      }
    </div>

    <div class="form-group w-full">
      <label
        class="input-label label-large-medium text-primary-color mb-spacing-default flex gap-spacing-default align-items-center"
        for="body"
        >Notification Body <span class="feedback-danger-fg-color">*</span></label
      >
      <textarea
        rows="5"
        cols="30"
        id="body"
        formControlName="body"
        pTextarea
        [autoResize]="true"
        placeholder="Write your message here"
        class="w-full">
      </textarea>
      @if (form.get("body")?.invalid && form.get("body")?.touched) {
        <small class="p-error">Message is required </small>
      }
    </div>
  </form>
</div>

<!-- Second dialog -->
<p-dialog
  [showHeader]="false"
  [modal]="true"
  [(visible)]="confirmationDialogVisible"
  [style]="{ width: '400px' }">
  <div class="p-dialog-header px-0">
    <span class="background-muted-warning-bg flex p-spacing-xs border-round-md">
      <i class="icon-warning-circle-solid text-xl icon-warning-color"></i>
    </span>
    <div class="p-dialog-header-icons">
      <app-button
        (btnClick)="closeConfirmDialog()"
        [iconOnlyButton]="true"
        icon="icon-x"
        sizeClass="p-button-sm"
        severity="secondary"
        [textButton]="true"></app-button>
    </div>
  </div>

  <div class="flex flex-column gap-spacing-xs">
    <h5 class="mb-0 title-small-bold text-primary-color">Send Mass Notification Now</h5>
    <p class="mb-0 label-large-medium text-caption-color">Send mass notification now will notify all guardians Immediately. Are you sure you want to proceed?</p>
  </div>

  <div class="footer py-spacing-2xl px-0 gap-spacing-xl flex justify-content-end gap-spacing-xl">
    <app-button
      label="Cancel"
      (btnClick)="closeConfirmDialog()"
      sizeClass="p-button-md"
      severity="secondary"></app-button>
    <app-button
      label="Proceed"
      (btnClick)="confirmAction()"
      sizeClass="p-button-md"
      severity="primary"></app-button>
  </div>
</p-dialog>
<!-- End Second dialog -->

<div class="footer py-spacing-2xl px-0 gap-spacing-xl flex justify-content-end gap-spacing-xl">
  <app-button
    label="Cancel"
    (btnClick)="ref.close()"
    sizeClass="p-button-md"
    severity="secondary"></app-button>
  <app-button
    [isLoading]="loading()"
    [iconStart]="loading() ? 'icon-spinner-gap' : ''"
    [disabled]="form.invalid || loading()"
    [label]="'Send Notification'"
    (btnClick)="openConfirmDialog()"
    sizeClass="p-button-md"
    severity="primary"></app-button>
</div>
